const setSecondChildrenName = (data = null) => {
  return {
    type: 'SET_SECONDCHILDRENNAME',
    data
  }
}

export default {
  setSecondChildrenName,
}
